<!-- <kendo-tilelayout-item [col]="numberOfCols">
  <kendo-tilelayout-item-header>
    <span>
      <h3>Test Tile 1</h3>
      <button kendoButton fillMode="flat" (click)="closeTile()"> <fa-icon class="fa-solid fa-duotone"
          [icon]="['fad', 'xmark']"></fa-icon></button>
    </span>
  </kendo-tilelayout-item-header>
  <kendo-tilelayout-item-body>
    {{ tileContent }}
  </kendo-tilelayout-item-body>
</kendo-tilelayout-item> -->
<p>
  Wally Rules
</p>
